/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Fragment as _ } from 'react';
import { colors } from 'styles/variables';
import EditMarker from 'components/UI/EditMarker';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { useSelector } from 'react-redux';

const { lPink, lGrey2 } = colors;

const EditCardWrapper = ({ id }) => {
  const focusedNodeId = useSelector((state: any) => state.focusedNodeId);
  const selected = focusedNodeId === id;

  const gutter = 9;

  return (
    <div
      css={css({
        position: 'absolute',
        left: gutter,
        top: gutter,
        width: `calc(100% + ${-(gutter * 2)}px)`,
        height: `calc(100% + ${-(gutter * 2)}px)`,
        boxShadow: `${selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'}`,
        ...(!selected && {
          cursor: 'pointer',

          '&:hover': {
            boxShadow: `0 0 0 1px ${lPink}`,
          },
        }),
        transition: 'box-shadow 0.2s, border-radius 0.2s',
      })}
      onClick={e => {
        e.stopPropagation();

        if (selected) return;

        setCurrentBlock({ id });
      }}
    >
      {!selected && (
        <EditMarker
          style={{
            right: 0,
            zIndex: '2147483647',
          }}
        />
      )}
    </div>
  );
};

export default EditCardWrapper;
